import { Heart, Sparkles, Users, Coffee, MessageCircle, Award, Palette, MessageSquare, Network } from "lucide-react";
import { Link } from "react-router-dom";
import useDocumentTitle from "@/hooks/useDocumentTitle";

const VALUES = [
  { icon: Heart, title: "Prawda, nie lukier", desc: "Rozmawiamy o tym, jak jest naprawdę — z macierzyństwem, ze związkiem, ze złością i miłością." },
  { icon: Sparkles, title: "Wiedza z pierwszej ręki", desc: "10 ekspertek, które łączą wykształcenie z doświadczeniem bycia mamą. Spotkanie, wymiana, inspiracja." },
  { icon: Users, title: "Twoja przestrzeń", desc: "Poznajesz kobiety, które rozumieją Cię w pół zdania. Zostają na dłużej." },
  { icon: Coffee, title: "Tempo mamy", desc: "Wygodne fotele, długie przerwy, kawa taka jak lubisz, cichy pokój dla karmiących. Zero wyścigu." },
  { icon: MessageCircle, title: "Q&A po każdym warsztacie", desc: "Możliwość prywatnych rozmów z prowadzącymi warsztaty." },
  { icon: Award, title: "Na wynos", desc: "A co jeśli zabierzesz ze sobą więcej niż planowałaś? Wyjdziesz nie tylko z głową pełną pomysłów, ale także z torbą pełną dobra." },
  { icon: Palette, title: "Sztuka jest kobietą", desc: "Piękna wiedza w pięknym wnętrzu. Przestrzeń, która pobudza kreatywność i sprzyja wyjątkowym spotkaniom." },
  { icon: MessageSquare, title: "Panel dyskusyjny", desc: "Macierzyństwo z różnych stron. Osobiste historie, wymiana poglądów, inspirująca dyskusja." },
  { icon: Network, title: "Networking", desc: "Zostaw swoją myśl na ściance, rozgość się przy stolikach tematycznych i zobacz, dokąd zaprowadzą Cię te spotkania." },
];

export default function About() {
  useDocumentTitle("O kongresie", "Dowiedz się, czym jest mamy!kongres — jedyny taki dzień dla mam, pełen inspirujących kobiet, warsztatów i prawdziwych rozmów.");
  return (
    <div>
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-8 pb-16">
        <div className="text-xs uppercase tracking-[0.3em] text-[#E6007A] mb-6">O kongresie</div>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] mb-8">
          Tworzymy dzień, w którym <span className="italic text-[#E6007A]">mama</span> jest w centrum uwagi.
        </h1>
        <p className="text-xl text-[#5C534D] leading-relaxed max-w-3xl">
          Zaczęło się od dwóch mam i pytania przy wspólnej kawie:<br />
          „Dlaczego nie ma takiego wydarzenia, na które chciałybyśmy pójść?".<br />
          Myślenie przełożyło się na realizację i ...{" "}
          <span className="font-display text-[#2B2623]">
            mamy<span className="text-[#E6007A]">!</span>kongres
          </span>.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-16">
        <div className="rounded-[48px] overflow-hidden aspect-[21/9]">
          <img
            src="https://customer-assets-cm19k8pv.emergentagent.net/job_mama-congress/artifacts/u2jaii6k_image.png"
            alt="Mamy przy stoliku – rozmowa"
            className="w-full h-full object-cover"
          />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <h2 className="font-display text-4xl md:text-5xl mb-14 max-w-2xl">Dlaczego to działa</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {VALUES.map((v, i) => (
            <div key={i} className="rounded-3xl bg-white border border-[#E8E1D9] p-8 hover:border-[#E6007A] transition-colors" data-testid={`value-${i}`}>
              <v.icon className={`w-8 h-8 mb-5 ${i % 2 ? "text-[#2E4331]" : "text-[#E6007A]"}`} />
              <h3 className="font-display text-2xl mb-3">{v.title}</h3>
              <p className="text-[#5C534D] leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#F4EFE6] py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <div className="font-display text-6xl md:text-7xl text-[#E6007A] mb-6">„</div>
          <blockquote className="font-display text-2xl md:text-3xl leading-snug italic mb-8 text-[#2B2623]">
            Sukces każdej kobiety powinien być inspiracją dla innej. Powinnyśmy się nawzajem wspierać.
            Upewnij się, że jesteś odważna: bądź silna, bądź niezwykle życzliwa, a przede wszystkim
            bądź pokorna.
          </blockquote>
          <div className="text-[#5C534D]">— Serena Williams</div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-24 text-center">
        <h2 className="font-display text-4xl md:text-5xl mb-6">Widzimy się 22 maja 2027.</h2>
        <Link
          to="/zapisz-sie"
          data-testid="about-cta-register"
          className="btn-lift inline-flex items-center rounded-full bg-[#E6007A] px-8 py-4 text-white font-semibold"
        >
          Zapisuję się
        </Link>
      </section>
    </div>
  );
}
